import { FlashbarProps } from '@amzn/awsui-components-core';
import { createContext, useContext } from 'react';
import { StatusType } from '../sas/SasInterfaces';
import { DogmaDetailsTabData, DogmaGraphData } from './DogmaInterface';

export type DogmaContextType = {
  displayNotification: (status: FlashbarProps.Type, message: string, linkMessage?: string) => void;

  dogmaGraphStatus: StatusType;
  setDogmaGraphStatus: (status: StatusType) => void;

  dogmaGraphData: DogmaGraphData;
  setDogmaGraphData: (graphData: DogmaGraphData) => void;

  dogmaDetailsTabStatus: StatusType;
  setDogmaDetailsTabStatus: (status: StatusType) => void;

  dogmaDetailsTabData: DogmaDetailsTabData;
  setDogmaDetailsTabData: (dogmaDetailsData: DogmaDetailsTabData) => void;

  // Access filters' values for summary
  summaryFilters: string;
  setSummaryFilters: (filters: string) => void;
  // Original filter options for summary processing
  originalFilterOptions: string;
  setOriginalFilterOptions: (options: string) => void;
};

export const DogmaContext = createContext<DogmaContextType>({
  displayNotification: (status: FlashbarProps.Type, message: string, linkMessage?: string) => {},

  dogmaGraphStatus: 'pending',
  setDogmaGraphStatus: (status: StatusType) => {},

  dogmaGraphData: {} as DogmaGraphData,
  setDogmaGraphData: (graphData: DogmaGraphData) => {},

  dogmaDetailsTabStatus: 'pending',
  setDogmaDetailsTabStatus: (status: StatusType) => {},

  dogmaDetailsTabData: {} as DogmaDetailsTabData,
  setDogmaDetailsTabData: (dogmaDetailsData: DogmaDetailsTabData) => {},

  summaryFilters: '',
  setSummaryFilters: (filters: string) => {},
  originalFilterOptions: '',
  setOriginalFilterOptions: (options: string) => {}
});

export const useDogmaContext = () => useContext(DogmaContext);
